import React, { useEffect, useState } from "react";
import axios from 'axios';
import Button from "../../../components/Button";
import ItemForm from "../../../components/ItemForm";
import ModalContent from "../../../components/ModalContent";
import ModalButtons from "../../../components/ModalButtons";
import ToastMessage from "../../../components/ToastMessage";
import Loader from "../../../components/Loader";
import {validateField} from "../../../utils/validateField";
import { useNewContact } from "../../../context/contextNewContact";
import { useColorMode } from "../../../context/contextColorMode";

import { FormContact, CEPData } from "../styles";

const Number = ({ navigation }) => {
  const [error, setError] = useState(false);
  const {isEnabled} = useColorMode();
  const [cepData, setCepData] = useState({});
  const { number, cep, setNumber } = useNewContact();

  const { next, previous } = navigation;

  useEffect(() => {
    axios
      .get(`http://viacep.com.br/ws/${cep}/json/`)
      .then((response) => {
        setCepData(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [cep]);

  return (
    <>
      {error ? (
        <ToastMessage
          variant="info"
          message="Preencha este campo antes de continuar!"
        />
      ) : null}
      <ModalContent displayFlex={true}>
        {cepData !== null ? (
          <CEPData darkMode={isEnabled}>
            <h3>{cepData.logradouro}</h3>
            <h4>
              {cepData.bairro} - {cepData.localidade} - {cepData.uf}
            </h4>
          </CEPData>
        ) : (
          <Loader />
        )}
        <FormContact style={{ padding: "6.875rem 0" }} darkMode={isEnabled}>
          <h2>POR FAVOR, INFORME O NÚMERO DO ENDEREÇO</h2>
          <ItemForm
            placeholder="Digite aqui"
            name="number"
            type="number"
            value={number}
            onChange={e=>setNumber(e.target.value)}
          />
        </FormContact>
      </ModalContent>
      <ModalButtons>
        <Button
          bgcolor="var(--blue)"
          color="#fff"
          border="var(--blue)"
          hover="var(--blue-hover)"
          expansive={true}
          hollow={false}
          size="small"
          onClick={async () => {
            await validateField(number, 'text', next, setError);
            setError(false);
          }}
        >
          CONTINUAR
        </Button>
        <hr />
        <Button
          color="var(--gray)"
          border="var(--gray)"
          expansive={true}
          hollow={true}
          size="small"
          onClick={previous}
        >
          VOLTAR
        </Button>
      </ModalButtons>
    </>
  );
};

export default Number;
